var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { DataArrayError, NumberClassError } from "./errors";
export var validateNumberClasses = function (numberClasses, arrayLength) {
    if (!Number.isInteger(numberClasses))
        throw TypeError("Number classes must be an integer");
    if (numberClasses > arrayLength)
        throw new NumberClassError("Number classes must be less than array length");
    if (numberClasses <= 0)
        throw new NumberClassError("Number classes must be greater than zero");
};
export var validateDataArray = function (arrayLength) {
    if (arrayLength <= 0)
        throw new DataArrayError("Array length must be bigger than one");
};
export var calcStandardDeviation = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var n, mean;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                n = data.length;
                return [4 /*yield*/, calcMean(data)];
            case 1:
                mean = _a.sent();
                return [2 /*return*/, Math.sqrt(data.map(function (x) { return Math.pow(x - mean, 2); }).reduce(function (a, b) { return a + b; }) / n)];
        }
    });
}); };
export var calcMean = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var n;
    return __generator(this, function (_a) {
        n = data.length;
        return [2 /*return*/, data.reduce(function (a, b) { return a + b; }) / n];
    });
}); };
